// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__R_kkv","switch":"Header_switch__SGbDU","slider":"Header_slider__2e7qH","round":"Header_round__Flypr","settings":"Header_settings__fBnfp"};